<template>
  <dialog-email
    v-loading="isLoading"
    ref="dialogEmail"
    :data="data"
    :contentMap="contentMap"
    @on-submit-email="onSubmitEmail"
  >
  </dialog-email>
</template>

<script>
import { toDate } from '@/utils/filters'
import { ServiceContacts } from '@/services/Contacts'
import { ServiceInvoice } from '@/services/Invoice'
import { SECOND_EMAIL_REPLY_TO } from '@/utils/shared'
import { ServiceEmailMessages } from '@/services/email-messages'

const INVOICES_WITH_FULL_EMAIL_LIST_IDS = [3, 7]

export default {
  name: 'SendEmailWrap',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialog' */ '@/components/Dialogs/DialogEmail/index')
  },
  props: {
    invoiceID: { required: true }
  },
  data () {
    return {
      isLoading: false,
      logoType: 0,
      data: {},
      contentMap: {}
    }
  },
  methods: {
    onSubmitEmail (data) {
      return this.sendEmail(data)
    },
    async sendEmail (emailData) {
      this.isLoading = true
      const { invoiceTypeID, invoiceNumber } = this.data

      try {
        await ServiceEmailMessages.sendInvoice({
          id: this.invoiceID,
          logoKey: this.logoType,
          invoiceNumber,
          invoiceTypeID,
          translate: this.L10n,
          ...emailData
        })
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
        this.hide()
      }
    },
    async show ({ logoType }) {
      this.logoType = logoType

      try {
        const data = await this.loadData()

        let emailToList = [
          ...(data.customerEmail || '').replace(' ', '').split(';'),
          data.baxEmployeeEmail,
          ...data.dataCompanyContacts.map(({ email }) => email)
        ].filter(Boolean).map((email) => email.replace(' ', ''))

        emailToList = new Set(emailToList)

        this.contentMap = { ...data, poDate: toDate(data.poDate) }
        let additionalData = {
          invoiceID: this.invoiceID,
          invoiceTypeID: data.invoiceTypeID,
          invoiceNumber: data.invoiceNumber,
          body: data.emailContent,
          subject: `${data.title} № ${data.invoiceNumber}`,
          emailToList: Array.from(emailToList),
          replyTo: SECOND_EMAIL_REPLY_TO
        }
        this.data = Object.assign({}, additionalData)
        this.$refs.dialogEmail.show()
      } catch (e) {
        this.requestErrorHandler(e)
      }
    },
    hide () {
      this.logoType = 0
      this.$refs.dialogEmail.hide()
    },
    async loadData () {
      this.$emit('data-load')
      const { data } = await ServiceInvoice.getDynamic(this.invoiceID, {
        select: [
          'id', 'invoiceTypeID', 'invoiceNumber', 'invoiceType.emailContent as emailContent',
          'rfq.customerCompanyID as companyID',
          'rfq.baxEmployee.contact.email as baxEmployeeEmail',
          'rfq.customerContact.email as customerEmail', 'invoiceType.title as title',
          'rfq.customerContact.name as customerName', 'awb', 'rfq.shipToCompany.name as shipToCompanyName', 'po', 'rfq.poDate as poDate'
        ].join(',')
      })

      let dataCompanyContacts = []
      if (INVOICES_WITH_FULL_EMAIL_LIST_IDS.some((id) => id === data.invoiceTypeID) && data.companyID) {
        const { data: result } = await ServiceContacts.getInvoicePaymentContacts({ companyID: data.companyID })
        dataCompanyContacts = result.value
      }

      this.$emit('data-loaded')
      return { ...data, dataCompanyContacts }
    }
  }
}
</script>
